<template>
  <div v-if="loaded" class="flex flex-wrap items-center gap-2">
    <template v-if="iban">
      <SecondaryButton
        data-test="confirm-iban"
        :loading="confirming"
        color-class="bg-purple-100 hover:bg-purple-200 text-purple-700"
        @click="confirmIban"
      >
        <CreditCardIcon class="w-3 h-3 mr-1 shrink-0" />
        <span class="whitespace-nowrap text-base">{{ t("confirm_iban", { iban: maskedIban }) }}</span>
      </SecondaryButton>
      <SecondaryButton data-test="change-iban" @click="goToAccount">
        <span class="whitespace-nowrap text-base">{{ t("change_iban") }}</span>
      </SecondaryButton>
    </template>
    <SecondaryButton
      v-else
      data-test="provide-iban"
      color-class="bg-purple-100 hover:bg-purple-200 text-purple-700"
      @click="goToAccount"
    >
      <CreditCardIcon class="w-3 h-3 mr-1 shrink-0" />
      <span class="whitespace-nowrap text-base">{{ t("provide_iban") }}</span>
    </SecondaryButton>
  </div>
</template>

<script>
import { CreditCardIcon } from "@heroicons/vue/solid";
import { SecondaryButton, maskIban } from "@estaly/ui";
import { useI18n } from "vue-i18n";
import { mapActions } from "vuex";

// A claim refunded to the customer waits for their IBAN: the customer either provides one, or
// confirms (or replaces) the one already on file.
export default {
  components: { SecondaryButton, CreditCardIcon },
  props: {
    claim: { type: Object, required: true },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return { iban: null, loaded: false, confirming: false };
  },

  computed: {
    maskedIban() {
      return maskIban(this.iban?.value);
    },
  },

  async mounted() {
    const iban = await this.fetchIban();
    this.iban = iban?.value ? iban : null;
    this.loaded = true;
  },

  methods: {
    ...mapActions("iban", { fetchIban: "fetch", confirm: "confirm" }),
    ...mapActions("notifications", ["notify"]),

    async confirmIban() {
      this.confirming = true;
      try {
        const success = await this.confirm({ claimFriendlyId: this.claim.friendlyId });
        if (!success) return;

        this.notify({ category: "simple", type: "success", title: this.t("iban_confirmed") });
      } finally {
        this.confirming = false;
      }
    },

    goToAccount() {
      this.$router.push("/account");
    },
  },
};
</script>

<i18n src="./CustomerIbanAction.i18n.json"></i18n>
